import React from 'react';
import { Popover, Typography, Box } from '@mui/material';

const ContextDetailsPopover = ({
  open,
  anchorEl,
  onClose,
  anchorOrigin,
  transformOrigin,
  zIndex,
  maxWidth = 600,
  maxHeight = 400,
  title,
  content
}) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      disableAutoFocus
      disableEnforceFocus
      disableRestoreFocus
      sx={{ zIndex: zIndex }}
      PaperProps={{ sx: { p: 2, maxWidth, maxHeight, overflow: 'auto' } }}
    >
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        {title}
      </Typography>
      <Box component="pre" sx={{ m: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontFamily: 'monospace', fontSize: '0.75rem' }}>
        {content}
      </Box>
    </Popover>
  );
};

export default ContextDetailsPopover;
